"use client";
import { Tag, Typography, Card, Button } from "antd";
import { BOM } from "../../../../../services/definedMethod";
import { getCurrencySymbol } from "../../../../../components/facilities/TreasuryFacility";

const { Text } = Typography;

const Preview = (props) => {
  const {
    formData,
    interestTypeOptions,
    custodianOptions,
    placementTypeOptions,
    collateralTypeOptions,
    currencies,
    isCreateButton,
    contractRef,
    chargeData,
  } = props;

  const { contractInformation, terms, counterParty } = formData;

  // function getSymbol(templateProdDetail, contractInformation) {
  //     console.log(contractInformation, templateProdDetail);
  //     const currency = templateProdDetail?.currencies?.find((item, i) => item?.value === contractInformation?.currencyCode);
  //     console.log(currency, "currency");
  //     return currency?.symbol ?? currency?.value;
  //   }

  //   getSymbol(templateProdDetail, contractInformation);
  const collateralCurrency = contractInformation?.collateralCurrency;
  const currencySymbol = getCurrencySymbol(collateralCurrency, currencies);

  const data = [
    {
      section: "Contract Information",
      items: [
        {
          name: "Product Code",
          value: contractInformation.productCode || "--",
        },
        {
          name: "Product Name",
          value: contractInformation.productName || "--",
        },
        {
          name: "Inputter",
          value: contractInformation.initiatedBy || "--",
          isTag: true,
        },
        {
          name: "Product Currency",
          value: contractInformation.currencyCode || "--",
          isTag: true,
        },
        {
          name: "Custodian",
          value:
            custodianOptions?.find(
              (item) => item.value === contractInformation.custodian
            )?.label || "--",
          isTag: true,
        },
        {
          name: "Placement Type",
          value:
            placementTypeOptions?.find(
              (item) => item.value === contractInformation.placementType
            )?.label || "--",
          isTag: true,
        },
        {
          name: "Collateral Type",
          value:
            collateralTypeOptions?.find(
              (item) => item.value === contractInformation.collateralTypeId
            )?.label || "--",
          isTag: true,
        },
        {
          name: "Collateral Volume",
          value: contractInformation?.collateralVolume?.toLocaleString() ?? "-",
          type: "text",
        },
        {
          name: "Collateral Number",
          value: contractInformation?.collateralNumber ?? "-",
          type: "text",
        },
        {
          name: "Collateral Value",
          value:
            `${currencySymbol} ${Number(
              contractInformation?.collateralValue
            ).toLocaleString()}` || "--",
          type: "text",
        },
        {
          name: "Collateral Maturity Date",
          value:
            BOM.DateTime(contractInformation?.collateralMaturityDate) ?? "-",
          type: "text",
        },
        {
          name: "Collateral Reference",
          value: contractInformation?.collateralIdentifier ?? "-",
          type: "text",
        },
        {
          name: "Start Date",
          value: BOM.DateTime(terms?.startDate, "only-date") || "--",
          type: "text",
        },
        {
          name: "Maturity Date",
          value: BOM.DateTime(terms?.maturityDate, "only-date") || "--",
          type: "text",
        },
      ],
    },
    {
      section: "Terms",
      items: [
        {
          name: "Minimum Tenor",
          value: `${terms.minTenor} Days` || "--",
          type: "text",
        },
        {
          name: "Maximum Tenor",
          value: `${terms.maxTenor} Days` || "--",
          type: "text",
        },
        {
          name: "Default Tenor",
          value: `${terms.defaultTenor} Days` || "--",
          type: "text",
        },

        {
          name: "Amount Placed",
          value:
            `${contractInformation.currencyCode} ${Number(
              terms.amountPlaced
            ).toLocaleString()}` || "--",
          isTag: true,
        },

        {
          isInlineGroup: true,
          group: [
            {
              name: "Placement Fee",
              isTagGroup: true,
              fields: [
                {
                  value: terms.allowPlacementFee ?? "-",
                  isTag: true,
                },
                {
                  value:
                    terms.placementFee !== undefined
                      ? terms.placementFee
                        ? "With Penalty"
                        : "Without Penalty"
                      : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      section: "Tax & Charges",
      items: [
        {
          isInlineGroup: true,
          group: [
            {
              name: "Tax Group",
              isTagGroup: true,
              fields: [
                {
                  value: chargeData.allowTax ?? "-",
                  isTag: true,
                },
                {
                  value:
                    chargeData.taxGroup !== undefined
                      ? chargeData.taxGroup.name
                      : "-",
                  isTag: true,
                },
                {
                  value: chargeData?.taxGroup?.taxAssociations[0]?.taxComponent
                    ?.percentage
                    ? `%${chargeData?.taxGroup?.taxAssociations[0]?.taxComponent?.percentage?.toLocaleString()}`
                    : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      section: "Interest",
      items: [
        {
          name: "Interest Rate",
          value: `${terms.interestRate} %` || "--",
          type: "text",
          isTag: true,
        },
        {
          name: "Interest Type",
          //   value:terms.defaultTenor || "--",
          value:
            interestTypeOptions?.find(
              (item) => item.value === terms.interestType
            )?.label || "--",
          isTag: true,
        },

        {
          name: "Interest Calculation Basis",
          value: terms.interestCalculationBasis || "--",
          isTag: true,
        },
        {
          name: "Interest Posting Type",
          value: terms.interestPostingType || "--",
          isTag: true,
        },
      ],
    },

    {
      section: "CounterParty Settings",
      items: [
        {
          name: "Bank Code",
          value: counterParty.bankCode || "--",
          isTag: true,
        },
        {
          name: "Bank Name",
          value: counterParty.bankName || "--",
          isTag: true,
        },
        {
          name: "Institution Code",
          value: counterParty.institutionCode || "--",
          isTag: true,
        },

        {
          isInlineGroup: true,
          group: [
            {
              name: "Deal Confirmation",
              isTagGroup: true,
              fields: [
                {
                  value: counterParty.sendDealConfirmation ?? "-",
                  isTag: true,
                },
                {
                  value:
                    counterParty.email !== undefined ? counterParty.email : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          name: "KYC Status",
          value: counterParty?.kycStatus ?? "-",
          isTag: true,
        },
      ],
    },
  ];

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
            textTransform: "capitalize",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return <Text style={{ fontWeight: 500, color: "#6b7280" }}>-</Text>;
    }

    // Default tag for select fields
    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {value}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem = index === (data[section]?.items?.length || 0) - 1;

    if (item.isInlineGroup && Array.isArray(item.group)) {
      return (
        <div
          key={`inline-group-${section}-${index}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          {item.group.map((fieldGroup, groupIndex) => (
            <>
              <div
                key={`group-${groupIndex}`}
                style={{
                  width: "50%",
                  backgroundColor: "#f9f9f9",
                  padding: "16px 24px",
                  fontWeight: "500",
                  borderRight: "1px solid #f0f0f0",
                }}
              >
                {fieldGroup.name}
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#fff",
                }}
              >
                {fieldGroup.fields.map((subField) => (
                  <div
                    key={subField.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: 500,
                    }}
                  >
                    {subField.isTag ? (
                      renderTag(subField.value)
                    ) : (
                      <span>{subField.value}</span>
                    )}
                  </div>
                ))}
              </div>
            </>
          ))}
        </div>
      );
    }

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isTag ? (
            renderTag(item.value)
          ) : (
            <Text style={{ textTransform: "capitalize", fontWeight: 600 }}>
              {item.value}
            </Text>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <h1 style={{ fontSize: "24px", fontWeight: "700", margin: 0 }}>
          Preview
        </h1>
        <p style={{ marginTop: "5px", color: "#6b7280" }}>
          Overview of placement contract information
        </p>

        {!isCreateButton && (
          <h2 style={{ fontSize: "16px" }}>Contract ID: {contractRef}</h2>
        )}

        {data.map((section, sectionIndex) => (
          <div key={section.section}>
            <h2
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                marginBottom: "16px",
              }}
            >
              <div style={{ flexGrow: 1 }}> {section.section}</div>
            </h2>
            <div
              style={{
                border: "1px solid #f0f0f0",
                borderRadius: "8px",
                marginBottom: "24px",
              }}
            >
              {section.items.map((item, index) =>
                renderRow(item, index, sectionIndex)
              )}
            </div>
          </div>
        ))}
      </div>
      {/* <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "32px",
          gap: "12px",
        }}
      >
        <Button n style={{ height: "44px" }} onClick={onPrevious}>
          Previous
        </Button>
        <Button
          type="primary"
          style={{ backgroundColor: "#9F1AB1", height: "44px" }}
          onClick={onCreateProduct}
          loading={isCreatingProduct}
        >
          {isCreateButton ? "Create Contract" : "Update Contract"}
        </Button>
      </div> */}
    </>
  );
};

export default Preview;
